export default __webpack_public_path__ + "static/media/samsung_stimuli_fr.ad84f90c.mp4";